import { TailwindSpinner } from '@components/common';


// Interface
// *************************************
interface DisplayAmountsProps {
  label?: string,
  isLoading?: boolean,
  amount?: number,
}


/**
 * @description Renders a label and an amount. Used to display the price and discount in the credit calculator.
 *
 * - **label**: The label to be displayed.
 * - **isLoading**: If true, a spinner will be displayed instead of the amount.
 * - **amount**: The amount to be displayed.
 */
export const DisplayAmounts = (props: DisplayAmountsProps) => {
  // Props destructuring
  const {
    label,
    isLoading,
    amount,
  } = props;


  // Render component
  // *************************************
  return (
    <span className="flex justify-between py-1">
      { label }
      <strong className="flex items-center gap-1 text-secondary">
        <span>€</span>
        { // If loading, show spinner, else show amount or 0
          isLoading
            ? <TailwindSpinner className="size-4 text-ink-medium" />
            : amount ?? 0
        }
      </strong>
    </span>
  );
};
